import { Product } from '@hook/useProductFavorite';
import { ToastContainer } from '@components/ToastContainer';
import { ProductFavoritesToggleContainer } from '@containers/ProductFavoritesToggle';

interface Props {
  product: Product,
  onChange: () => void,
}

export const ProductFavorites: React.FC<Props> = ({
  product,
  onChange,
}) => {
  const handleChange = () => {
    onChange();
  };

  return (
    <>
      <ToastContainer />
      <ProductFavoritesToggleContainer
        product={product}
        type="Product"
        onChange={handleChange}
        isDetailed={true}
      />
    </>
  );
};
